import { render } from "./FlagLinks.vue?vue&type=template&id=568440a3"
import script from "./FlagLinks.vue?vue&type=script&lang=js"
export * from "./FlagLinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__